import {provideHttpClient, withInterceptors} from '@angular/common/http'
import {ApplicationConfig, inject, isDevMode, provideAppInitializer} from '@angular/core'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {provideRouter, withHashLocation, withInMemoryScrolling} from '@angular/router'
import {provideServiceWorker} from '@angular/service-worker'
import {
  authInterceptor,
  ConfigService,
  IConfig,
  responseInterceptor,
  SPB_LOGIN_SETTINGS,
  SPS_CONFIG
} from '@sparbanken-syd/sparbanken-syd-bankid'
import {environment} from '../environments/environment'
import {routes} from './app.routes'
import {LOCAL_STORAGE, SCAN_ROUTE_PATH, USER_ROLE, WINDOW} from './0-application/app'
import {QrFactory} from './0-application/qr-factory.class'
import {QR_SCANNER_FACTORY} from './0-application/qr-scanner.provider'
import {PwaService} from './services/pwa.service'

const configServiceConfig: IConfig = {
  authServiceUrl: environment.authServiceUrl,
  domain: environment.domain,
  adminRoles: [USER_ROLE]
}


export const appConfig: ApplicationConfig = {
  providers: [
    {provide: QR_SCANNER_FACTORY, useClass: QrFactory},
    {provide: SPS_CONFIG, useValue: configServiceConfig},
    {
      provide: SPB_LOGIN_SETTINGS, useValue: {
        text: 'Välkommen till tjänsten för verifiering av digitalt ID-kort. ' +
          'För att kunna använda tjänsten behöver du först ' +
          'identifiera dig med BankID.',
        buttonText: 'Logga in med BankID',
        route: ['/', SCAN_ROUTE_PATH]
      }
    },
    provideAppInitializer(() => {
      inject(PwaService)
      return inject(ConfigService).bootstrap()
    }),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {appearance: 'outline'}
    },
    provideRouter(routes, withHashLocation(), withInMemoryScrolling({anchorScrolling: 'enabled'})),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        responseInterceptor
      ])
    ),
    {
      provide: LOCAL_STORAGE,
      useFactory: () => localStorage
    },
    {
      provide: WINDOW,
      useValue: window
    },
    // With the new application builder @angular/build:application,
    // this provider is what enables the service worker.
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
}